import { useEffect, useCallback } from 'react';
import { logInfo } from '../../../../../utils/logger';

export const useMapBounds = (map, pois, routes) => {
  const calculateBounds = useCallback(() => {
    if (!map || (!pois?.length && !routes?.length)) return;

    const bounds = new google.maps.LatLngBounds();
    let hasValidPoints = false;

    // Add POI points to bounds
    pois?.forEach(poi => {
      const lat = Number(poi.coordinates?.latitude);
      const lng = Number(poi.coordinates?.longitude);
      if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
        bounds.extend({ lat, lng });
        hasValidPoints = true;
      }
    });

    // Add route points to bounds
    routes?.forEach(route => {
      route.trackPoints?.forEach(point => {
        const lat = Number(point.latitude);
        const lng = Number(point.longitude);
        if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
          bounds.extend({ lat, lng });
          hasValidPoints = true;
        }
      });
    });

    if (hasValidPoints) {
      // Add padding to bounds
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const latPadding = (ne.lat() - sw.lat()) * 0.1;
      const lngPadding = (ne.lng() - sw.lng()) * 0.1;
      bounds.extend({ lat: ne.lat() + latPadding, lng: ne.lng() + lngPadding });
      bounds.extend({ lat: sw.lat() - latPadding, lng: sw.lng() - lngPadding });
      
      map.fitBounds(bounds, {
        padding: { top: 50, right: 50, bottom: 50, left: 50 }
      });
      
      logInfo('Map bounds updated');
    }
  }, [map, pois, routes]);

  useEffect(() => {
    calculateBounds();
  }, [calculateBounds]);

  return { calculateBounds };
};